
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess } from 'src/globals';
import { class_returndata } from 'src/types/class_returndata'; 
import { Router } from '@angular/router';
import { cClass } from 'src/types/class';
import {MessageService} from 'primeng/api';

import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { cScheduledSession } from 'src/types/scheduledsession';

import { v4 as uuidv4  } from 'uuid';
import { scheduledsession_returndata } from 'src/types/scheduledsession_returndata';
import { admission_returndata } from 'src/types/admission_returndata';
import { resourceType_returndata } from 'src/types/resource_returndata';
import { cResource } from 'src/types/resource';
import { cMembershipadmission } from 'src/types/membershipadmissions';
import { emailtemplate_returndata } from 'src/types/emailtemplate_returndata';
import { BusyService } from '../_services/busy.service';


@Component({
  selector: 'app-scheduledsessionedit',
  templateUrl: './scheduledsessionedit.component.html',
  styleUrls: ['./scheduledsessionedit.component.css']
})
export class ScheduledSessioneditComponent  implements OnInit {
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  ScheduledSession: any;
  httpResponse: any;
  id: string;
  pageReady: boolean = true;

  scheduledsessionNameValid: boolean = true;
  scheduledsessionDescValid: boolean = true;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  ScheduledSessionList: any;

  TimeHours: any[] = [];
  TimeMins: any[] = [];

  ScheduledSessionDate: Date;
  ScheduledSessionTimeHours: string = "00";
  ScheduledSessionTimeMins: string = "00";
  newDate: Date;

  dateValid: boolean = true;

  FileChosen: string = "";

  Identifier: string = uuidv4();
  
  HTMLbmxurl: string = bmxurl;

  availableAdmissions: any = [];

  availableResources: any = [];

  EmailTemplates: any = [];

  admissionsValid: boolean = true;
  emailTemplateValid: boolean = true;
  activeIndex: number = 0;

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  BookingQuestionnaires: any[] = [];

  stateOptions: any[] = [];
  
  constructor(private busyService: BusyService, private route: ActivatedRoute, private http: HttpClient, private router: Router, private messageService: MessageService, private globalService: GlobalService) { 
    this.ScheduledSession = {
      id: null,
      scheduledsessionid: null,
      name: "",
      disabled: false,
      venueid: this.VenueID,
      startdate:"",
      duration: 1,
      durationtype: "FIXED",
      numberofplaces: 1,
      numberofweeks: 1,
      maxbookings: 0,
      description: "",
      imageurl: "",
      price: 0,
      colour: "#1c7eb3",
      questionaire: null,
      emailtemplate: null,
      membershipadmissions: [],
      resources: [],
    }

    this.clampMaxBookings();

    this.loadQuestionnaires();

    this.loadAdmissions(false);

    this.loadResources(false);

    this.http.get(bmxurl + "/EmailTemplateList/" + this.VenueID + "/false").subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.EmailTemplates = (response as emailtemplate_returndata).data;
      }
      else
      {
        this.messageService.add({severity:'warn', summary:'Response Message', detail: this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Email Templates, error: ' + error.messages});
    });

    this.newDate = new Date();

    this.stateOptions = [
      {label: 'Yes', value: true},
      {label: 'No', value: false}
    ];

    this.TimeHours = [
      {name: '00', code: '00'},
      {name: '01', code: '01'},
      {name: '02', code: '02'},
      {name: '03', code: '03'},
      {name: '04', code: '04'},
      {name: '05', code: '05'},
      {name: '06', code: '06'},
      {name: '07', code: '07'},
      {name: '08', code: '08'},
      {name: '09', code: '09'},
      {name: '10', code: '10'},
      {name: '11', code: '11'},
      {name: '12', code: '12'},
      {name: '13', code: '13'},
      {name: '14', code: '14'},
      {name: '15', code: '15'},
      {name: '16', code: '16'},
      {name: '17', code: '17'},
      {name: '18', code: '18'},
      {name: '19', code: '19'},
      {name: '20', code: '20'},
      {name: '21', code: '21'},
      {name: '22', code: '22'},
      {name: '23', code: '23'}
      ];
   
    this.TimeMins = [
        {name: '00', code: '00'},
        {name: '05', code: '05'},
        {name: '10', code: '10'},
        {name: '15', code: '15'},
        {name: '20', code: '20'},
        {name: '25', code: '25'},
        {name: '30', code: '30'},
        {name: '35', code: '35'},
        {name: '40', code: '40'},
        {name: '45', code: '45'},
        {name: '50', code: '50'},
        {name: '55', code: '55'},
      ];
  }

  loadAdmissions(showdisabled: boolean) {
    this.http.get(bmxurl + "AdmissionList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.availableAdmissions = (response as admission_returndata).data;
    }, error => {
    });
  }
    
  //0 means no limit, so that is where a session saved before this setting existed lands -
  //it says "unrestricted" outright rather than writing a number that would then drift every
  //time the places count changed. Above 0 the figure can never exceed the number of places:
  //the spinner's [max] stops anyone typing past it, but it does not retrospectively correct
  //a figure that is already too high, which is what happens when the places count drops.
  //Takes the count as an argument rather than reading the model, so it does not depend on
  //(ngModelChange) firing after the two-way binding has written the new value.
  clampMaxBookings(numberofplaces: number = null)
  {
    let places = Number(numberofplaces == null ? this.ScheduledSession.numberofplaces : numberofplaces);

    if(places == null || isNaN(places) || places < 1)
      places = 1;

    if(this.ScheduledSession.maxbookings == null)
      this.ScheduledSession.maxbookings = 0;

    if(this.ScheduledSession.maxbookings > places)
      this.ScheduledSession.maxbookings = places;

    if(this.ScheduledSession.maxbookings < 0)
      this.ScheduledSession.maxbookings = 0;
  }

  loadResources(showdisabled: boolean) {
    this.http.get(bmxurl + "ResourceList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.availableResources = (response as resourceType_returndata).data.filter(obj => obj.eventid == null || obj.eventid == '');
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Resources, error:' + error.messages});
    });
  }

  loadQuestionnaires(){
    this.http.get(bmxurl + "QuestionnaireList/" + this.VenueID).subscribe(response => {
      this.BookingQuestionnaires = (response as any).data;
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Questionnaires, error:' + error.messages[0]});
    });
  }

   removeImage(){
      this.FileChosen = null;
      this.ScheduledSession.imageurl = null;
  }

  next()
  {
    this.activeIndex = 1;
  }

  nextRes()
  {
    this.activeIndex = 2;
  }

  AddToResources(resource){
    if(this.ScheduledSession.resources == null)
      this.ScheduledSession.resources = [];

    let newRes: cResource = {
      groupname: "",
      id: uuidv4(),
      resourceId: resource.resourceId,
      name: resource.name,
      useClasses: resource.useClasses,
      exclusive: resource.exclusive,
      eventid: resource.eventid,
      concurrentUses: resource.concurrentUses,
      maxConcurrent: resource.maxConcurrent,
      disabled: resource.disabled,
      venueId: resource.venueId,
      colour: resource.colour,
      orderindex: resource.orderindex,
      length: resource.length,
      classes: resource.classes,
      showonbooking: resource.showonbooking,
      resources: resource.resources,
      isresourcecontainer: resource.isresourcecontainer,
      isconstructed: resource.isconstructed,
      price: resource.price,
      fixedprice: resource.fixedprice,
      resourcegroupname: resource.resourcegroupname,
      tags: resource.tags,
      resourcegroup: resource.resourcegroup,
      selectionmode: resource.isresourcecontainer ? "SYSTEMANY" : "",
      selectableresources: resource.selectableresources,
      startwhen: "ATSTART",
      startTimeOffset: 0,
      optional: false,
      quantityselector: "GROUPSIZE",
      quantity: resource.quantity,
      mode: resource.isresourcecontainer ? "COMPLEX" : "SIMPLE",
      inline: !resource.isresourcecontainer,
      ignore: false,
      admissions: null,
      inProgress: true,
      originatingid: '',
      wasoptional: false,
      wasselected: false,
      isupgrade: false,
      packageupgradeid: null,
      showinitinerary: true,
      showondaysheet: true,
      cansplit: false
    }

    this.ScheduledSession.resources.push(newRes);
    newRes = null;
  }

  removeFromResources(resource){
    this.ScheduledSession.resources = this.ScheduledSession.resources.filter(obj => obj.id !== resource.id);
  }

  AddToAdmissions(admission){
    if(this.ScheduledSession.membershipadmissions == null)
      this.ScheduledSession.membershipadmissions = [];

    let newAdm: cMembershipadmission = {
      id: uuidv4(),
      index: 0,
      name: admission.name,
      membershipadmissionid: uuidv4(),
      min: 0,
      max: 0,
      price: 0,
      detailsrequired: false,
      admissionid: admission.admissionid,
      numberofadmissions: 0,
      participant: true,
      membershiptypeid: this.ScheduledSession.membershiptypeid,
      questionnaire: admission.questionnaire,
      inprogress: true,
      admissionsindex: admission.admissionsindex
    }

    this.ScheduledSession.membershipadmissions.push(newAdm);
    this.availableAdmissions = this.availableAdmissions.filter(obj => obj.admissionid !== admission.admissionid);

    if(this.ScheduledSession.membershipadmissions.length == 0)
      {
        this.admissionsValid = false;
    }
    else
    {
      this.admissionsValid = true;
    }
  }

  removeFromAdmissions(admission){
    this.ScheduledSession.membershipadmissions = this.ScheduledSession.membershipadmissions.filter(obj => obj.admissionid !== admission.admissionid);

    if(this.ScheduledSession.membershipadmissions.length == 0)
    {
        this.admissionsValid = false;
    }
    else
    {
      this.admissionsValid = true;
    }
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");
    this.AccessAllowed = true;

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("CLASSES", user)){
          this.AccessAllowed = true;

          this.id = this.route.snapshot.paramMap.get('id');
          if(this.id != "0")
          {
            this.pageReady = false;
            this.http.get(bmxurl + "scheduledsession/" + this.VenueID + "/" + this.id).subscribe(response => {
              this.httpResponse = (response as scheduledsession_returndata)
              if (this.httpResponse.succeeded)
              {
                this.ScheduledSession = this.httpResponse.data;

                this.ScheduledSession.durationtype = "FIXED";

                if(this.ScheduledSession.resources == null)
                  this.ScheduledSession.resources = [];

                this.clampMaxBookings();

                this.ScheduledSessionDate = new Date(Number(this.ScheduledSession.startdate.substring(0,4)), Number(this.ScheduledSession.startdate.substring(5,7)) - 1, Number(this.ScheduledSession.startdate.substring(8,10)));
                this.ScheduledSessionTimeHours = this.ScheduledSession.startdate.substring(11,13);
                this.ScheduledSessionTimeMins = this.ScheduledSession.startdate.substring(14,16);

                this.FileChosen = this.ScheduledSession.imageurl;

                this.pageReady = true;
              }
              else
              {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting classes'});
                this.pageReady = false;
              }
            }, error => {
              this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting classes, error:' + error.messages[0]});
              this.pageReady = false;
            });
          }
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  stringifyDate(Year: number, Month: number, Day: number, Hour: number, Mins: number): string
  {
    let returnString = "";

    returnString = Year + "-" +  ('00' + (Month + 1).toString()).slice(-2) + "-" +  ('00' + Day.toString()).slice(-2)+ "T" + ('00' + Hour.toString()).slice(-2) + ":" + ('00' + Mins.toString()).slice(-2) + ":00.0000Z";

    return returnString;
  }

  uploadedFile(event){
    this.ScheduledSession.imageurl = event.originalEvent.body.data;
    let newNonce = uuidv4();

    this.FileChosen = event.originalEvent.body.data + "?n=" + newNonce;
  }

  onErrorFileUpload(event){
    this.messageService.add({ severity: 'error', summary: 'Image not uploaded', detail: 'Could not upload image: ' + event.error });
  }

  updateData()
  {
    this.busyService.busy();

    if (this.DoValidCheck())
    {
      let index = 0;
      this.ScheduledSession.membershipadmissions.forEach(adm => {
        adm.index = index;
        index++;
      });

      let startdatestring = "";
      startdatestring = this.stringifyDate(new Date(this.ScheduledSessionDate).getFullYear(), new Date(this.ScheduledSessionDate).getMonth(), new Date(this.ScheduledSessionDate).getDate(), Number(this.ScheduledSessionTimeHours), Number(this.ScheduledSessionTimeMins));
      this.ScheduledSession.startdate = startdatestring;

      if(this.id == "0")
      {
        this.http.post<cClass>(bmxurl + "/scheduledsession", this.ScheduledSession).subscribe(response => {
          this.httpResponse = response
            if(this.httpResponse.succeeded)
            {
              this.messageService.add({severity:'success', summary:'Saved', detail:'Session successfully created'});
              this.router.navigateByUrl("/scheduledsessions");

              this.busyService.idle();
            }
            }, error => {
              this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
              this.busyService.idle();
          })
      }
      else
      {
        this.ScheduledSession.disabled = false;

        this.http.put<cClass>(bmxurl + "/scheduledsession", this.ScheduledSession).subscribe(response => {
        this.httpResponse = response
          if(this.httpResponse.succeeded)
          {
            this.messageService.add({severity:'success', summary:'Saved', detail:'Session successfully updated'});
            this.router.navigateByUrl("/scheduledsessions");

            this.busyService.idle();
          }
          }, error => {
            this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
            this.busyService.idle();
        })

      }
    }
  }

  onQuestionnaireChange()
  {
      let birthdayQuestionFound = false;
    this.ScheduledSession.questionnaire.bookingquestions.forEach(q => {
      if(q.questiontype == "BIRTHDAY" || q.questiontype == "REGISTER")
      {
        birthdayQuestionFound = true;
      }
    });

    if(birthdayQuestionFound)
    {
      this.messageService.add({ severity: 'error', summary: 'Invalid Questionnaire', detail: 'Questionnaires for Scheduled Sessions must not contain birthday or register questions' });
      this.ScheduledSession.questionnaire = null;
    }
  }

  DoValidCheck()
  {
    let AllValid = true;

    if(this.admissionsValid == false)
    {
      AllValid = false;
    }

    if(this.ScheduledSession.emailtemplate == null || this.ScheduledSession.emailtemplate == undefined)
    {
      AllValid = false;
      this.emailTemplateValid = false;
    }
    else
    {
      this.emailTemplateValid = true;
    }

    if(this.ScheduledSession.name == null || this.ScheduledSession.name == "")
    {
      AllValid = false;
      this.scheduledsessionNameValid = false;
    }
    else
    {
      this.scheduledsessionNameValid = true;
    }

    return AllValid;
  }

  returnToList()
  {
    this.router.navigateByUrl("/scheduledsessions");
  }
}
